<template>
  <section class="inner-wrapper confirmation">
    <div class="left">
      <h2 class="confirmation__header">
        <strong>Thank You! We're Processing Your Order.</strong>
      </h2>
      <p class="mb-1">
        <strong>We'll send you a confirmation email at {{customerEmail}}.</strong>
      </p>
      <p class="mb-1">
        <strong>Please make sure to thoroughly read your rental agreement and our tips on avoiding dumpster rental fees.</strong>
      </p>
      <p class="mb-1">A member of our team will reach out if we have any questions about your placement location or permits.</p>
      <p class="mb-1">In the meantime, check out the resources below to prepare for your dumpster rental.</p>

      <h3 class="confirmation__header--small mt-2">How to Prep for a Dumpster Delivery</h3>
      <p class="mb-1">
        Once you've scheduled your dumpster rental, you'll need to prepare the drop-off location to ensure a successful delivery. Watch the video and check out the tips below to get ready for your container's arrival.
      </p>
      <div v-html="servicePageVideo"/>
      <a class="btn btn--secondary mt-3 mb-2" v-if="isBrandBD" href="https://www.budgetdumpster.com/resources/dumpster-delivery-tips.php">
        More Delivery Tips &amp; Guidelines
      </a>
    </div>
    <div class="right-column">
      <div class="right-column__sticky">
        <div class="summary-wrapper summary-wrapper--confirmation">
          <OrderSummary :hideEdit="true" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import config from '@/config'
import OrderSummary from '@/components/OrderSummary.vue'
import { timestamp, isGoogleEventsReady, getClientID } from '@/utilities.js'

const { servicePageVideo, phoneNumber } = config
export default {
  name: 'Confirmation',
  components: {
    OrderSummary
  },
  beforeRouteEnter (to, from, next) {
    if (to.name === 'Confirmation' && from.name !== 'Payment') {
      next('/')
    } else {
      next()
    }
  },
  data () {
    return {
      servicePageVideo,
      phoneNumber
    }
  },
  computed: {
    isBrandBD () {
      return process.env.VUE_APP_BRAND === 'BD'
    },
    customerEmail () {
      return this.$store.state.customer.email || 'test@test.com' // TODO: remove this later
    }
  },
  mounted () {
    if (isGoogleEventsReady()) {
      const time = timestamp()
      window.gtag('event', 'generate_lead')
      window.gtag('event', 'Ecommerce - PageView', {
        event_category: 'Ecommerce',
        event_label: `${time}~${window.location.href}`,
        send_to: process.env.VUE_APP_UA_ID
      })

      window.gtag('event', 'Ecommerce - PageView', {
        event_category: 'Ecommerce',
        timestamp: time,
        page: 'confirmation',
        bd_client_id: getClientID(),
        send_to: process.env.VUE_APP_GA4_ID
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
